<template>
  <h1>Cast</h1>
  <div class="cast responsive">
    <div class="cast-card" v-for="c in castList" :key="c.Id">
      <div class="cast-image">
        <img :src="getImageUrl(c.Image)" :alt="c.Image" />
      </div>
      <div class="cast-name">
        <h2>{{ c.PlayedBy }}</h2>
        <h4>{{ c.Part }}</h4>
        <hr />
      </div>
      <div class="cast-desc">
        <p>{{ c.Desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const castList = [];
    const initcastList = function () {
      castList.push({
        Id: 1,
        Image: "juror1.jpg",
        PlayedBy: "Sydney Wright",
        Part: "Juror #1 (Forewoman)",
        Desc: "A small, petty woman who is impressed with the authority she has and handles herself quite formally.",
      });
      castList.push({
        Id: 2,
        Image: "juror2.jpg",
        PlayedBy: "Jacob Garofalo",
        Part: "Juror #2",
        Desc: "A meek, hesitant man who finds it difficult to speak his own thoughts for fear of being shouted down by the more powerful personalities in the room.",
      });
      castList.push({
        Id: 3,
        Image: "juror3.jpg",
        PlayedBy: "Joseph Calveric",
        Part: "Juror #3",
        Desc: "A very strong, very forceful, extremely opinionated man, intolerant of opinions other than his own; at the same time, a deeply wounded man who tries to hide his pain behind a loud  voice.",
      });
      castList.push({
        Id: 4,
        Image: "juror4.jpg",
        PlayedBy: "Ryan Hill",
        Part: "Juror #4",
        Desc: "Seems to be a man of wealth and position, and a practiced speaker who presents himself well at all times. His only concern is with the facts of the case and is often the voice of  reason and logic when fights break out amongst the others.",
      });
      castList.push({
        Id: 5,
        Image: "juror5.jpg",
        PlayedBy: "Lily Thorne",
        Part: "Juror #5",
        Desc: "A naive, frightened young woman who takes her obligations in this case very seriously, but finds it difficult to speak up when her elders have the floor.",
      });
      castList.push({
        Id: 6,
        Image: "juror6.jpg",
        PlayedBy: "Jake Seitz",
        Part: "Juror #6",
        Desc: "An honest man who comes upon his decisions slowly and carefully. A blue-collar worker who states his opinions honestly and bluntly.",
      });
      castList.push({
        Id: 7,
        Image: "juror7.jpg",
        PlayedBy: "Grace Sugrue",
        Part: "Juror #7",
        Desc: "A loud, flashy, glad-handed saleswoman who works in a department store and has more important things to do than sit in a jury. Quick to show temper and equally quick to form  opinions.",
      });
      castList.push({
        Id: 8,
        Image: "juror8.jpg",
        PlayedBy: "Mikey Mousaw",
        Part: "Juror #8",
        Desc: "A quiet, thoughtful gentleman. Sees all sides of every question and constantly seeks the truth. A man of strength tempered with compassion. Above all, a man who wants justice  to be done and will fight to see that it is.",
      });
      castList.push({
        Id: 9,
        Image: "juror9.jpg",
        PlayedBy: "Lily Dwyer",
        Part: "Juror #9",
        Desc: "An old woman. Gentle, mild, and long since defeated by life. She recognizes herself for what she is and tries to be the voice of experience and wisdom in the room.",
      });
      castList.push({
        Id: 10,
        Image: "juror10.jpg",
        PlayedBy: "Kaylyn Beachner",
        Part: "Juror #10",
        Desc: "An angry, bitter woman who antagonizes almost at sight. Also a bigot who places no value on any human life save her own.",
      });
      castList.push({
        Id: 11,
        Image: "juror11.jpg",
        PlayedBy: "Isabella Borte",
        Part: "Juror #11",
        Desc: "A refugee who came to this country as a young adult. She speaks with an accent and is ashamed, humble and almost subservient to the people around her. She will honestly  seek justice because she has suffered through so much injustice.",
      });
      castList.push({
        Id: 12,
        Image: "juror12.jpg",
        PlayedBy: "Johnny Lisi",
        Part: "Juror #12",
        Desc: "A slick, bright advertising man who tries to do the right thing, but is used to being overwhelmed by people with louder, brighter ideas.",
      });
      castList.push({
        Id: 13,
        Image: "judge.jpg",
        PlayedBy: "Connor Boyle",
        Part: "Judge / Guard",
        Desc: "The Judge of the Courts and Guardsman of the Jury over seeing justice, and the jurors' needs.",
      });
    };

    initcastList();

    const getImageUrl = (image) => {
      let imgs = require.context("../assets/Cast/", false, /\.jpg$/);
      return imgs("./" + image);
    };

    return {
      castList,
      getImageUrl,
    };
  },
};
</script>

<style>
.cast {
  margin: 0 15vw;
  display: flex;
  flex-direction: column;
}

.cast-card {
  display: grid;
  grid-template-columns: 1fr 3fr;
  background-color: white;
  border-radius: 10px;
  margin-bottom: 1rem;
  max-width: 900px;
}

.cast-image {
  grid-column: 1;
  grid-row-start: 1;
  grid-row-end: 3;
  padding: 1rem;
}

.cast-image > img {
  width: 100%;
  border-radius: 50%;
  box-shadow: gray 3px 3px 5px;
}

.cast-name {
  grid-column: 2;
  text-align: center;
  color: black;
  padding-right: 1rem;
}

.cast-desc {
  grid-column: 2;
  color: black;
  margin-right: 1rem;
}

@media screen and (max-width: 500px) {
  .cast-card {
    grid-template-columns: 2fr 3fr;
  }

  .cast-image {
    grid-row-start: 1;
    grid-row-end: 2;
    padding-bottom: 0;
  }

  .cast-desc {
    grid-row: 2;
    grid-column-start: 1;
    grid-column-end: 3;
    margin-left: 1rem;
  }
}
</style>
